let $tab = $('.tenders__tab');
let $contentTabOne = $('.tenders__tab1');
let $contentTabTwo = $('.tenders__tab2');

$tab.on('click', (e) => {
	let $target = $(e.currentTarget);
	let $attr = $target.attr('data-tab');

	$tab.removeClass('is-active');
	$target.addClass('is-active');

	if ($attr === 'tab1') {
		$contentTabOne.removeClass('is-hidden');
		$contentTabTwo.addClass('is-hidden');
	}

	if ($attr === 'tab2') {
		$contentTabTwo.removeClass('is-hidden');
		$contentTabOne.addClass('is-hidden');
	}
});
